import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/videos")({
  staticData: { title: "Videos" },
  component: () => <Outlet />,
});
